"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuideImage = exports.CareArrowImage = void 0;
exports.GuidesLink = GuidesLink;
exports.Title = exports.Images = exports.GuidesLinkContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _guidesLogo = _interopRequireDefault(require("./guides-logo"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _flexbox = require("../../elements/other/flexbox");
const GuidesLinkContainer = exports.GuidesLinkContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "GuidesLinkContainer",
  class: "pl-gcda3nc"
});
const Title = exports.Title = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Title",
  class: "pl-tgzyxsn"
});
const Images = exports.Images = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Images",
  class: "pl-i4b6re7"
});
const GuideImage = exports.GuideImage = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "GuideImage",
  class: "pl-g1xmoxcd"
});
const CareArrowImage = exports.CareArrowImage = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "CareArrowImage",
  class: "pl-ceydhlg"
});

/**
 * Footer Menu component.
 *
 * @param {Object} props React props
 * @param {string} props.title Text string
 * @param {string} props.href Href string
 * @param {string} props.ariaLabel Aria Label string
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function GuidesLink({
  id,
  title,
  href,
  ariaLabel
}) {
  return /*#__PURE__*/_react.default.createElement(GuidesLinkContainer, {
    id: `id-${id}`,
    "aria-label": ariaLabel,
    href: href,
    "data-cy": "guides-link"
  }, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(Images, null, /*#__PURE__*/_react.default.createElement(_guidesLogo.default, {
    id: "guides-logo"
  })));
}
GuidesLink.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  href: _propTypes.default.string,
  ariaLabel: _propTypes.default.string
};